import { render } from "./News2024FW.vue?vue&type=template&id=3e8ee9be&scoped=true"
import script from "./News2024FW.vue?vue&type=script&lang=js"
export * from "./News2024FW.vue?vue&type=script&lang=js"

import "./News2024FW.vue?vue&type=style&index=0&id=3e8ee9be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8ee9be"]])

export default __exports__